'use strict'
module.exports = {
    view_width: '4200px',
    view_height: '1350px',
    api_host: '/',
    debug: process.env.NODE_ENV !== 'production' && true
}



// WEBPACK FOOTER //
// ./src/config.js